<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-6 footer-copyright">
      <p class="mb-0">Copyright {{ year }} © POS - By Primates Consulting SPA</p>
    </div>
    <div class="col-md-6">
      <p class="pull-right mb-0">
        Made with <i class="fa fa-heart"></i> by Primates
      </p>
    </div>
  </div>
</div>
